import {Component, Inject, OnInit} from '@angular/core';
import {BaseCustomDialog} from "../base-custom-dialog";
import {ActionIconHelper} from "../../../../helper/action-icon.helper";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ACTION_DATA_SERVICE, ActionDataService} from "../../../../services/action/data.service";

@Component({
  selector: 'fi-lead-takeover',
  templateUrl: './lead-takeover.component.html',
  styleUrls: ['./lead-takeover.component.scss'],
  standalone: false,
})
export class LeadTakeoverComponent extends BaseCustomDialog implements OnInit {
  contactName = '';
  leadId: number;
  note = '';
  title: string;
  iconUrl = ActionIconHelper.getActionIconUrl('LEAD_TAKEOVER', false);
  darkIconUrl = ActionIconHelper.getActionIconUrl('LEAD_TAKEOVER', true);
  submitting: boolean;
  inValidNote = false;

  constructor(
    public dialogRef: MatDialogRef<LeadTakeoverComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: { contactName: string, leadId: number, leadTypeId: number, title: string },
    @Inject(ACTION_DATA_SERVICE) private actionDataService: ActionDataService
  ) {
    super(dialogRef);

    this.contactName = dialogData?.contactName || '';
    this.leadId = dialogData?.leadId;
    this.title = dialogData?.title;
  }

  ngOnInit(): void {
  }

  closeDialog(): void {
    this.clearClassAndCloseDialog(this.dialogRef);
  }

  get formIsValid(): boolean {
    return !!this.leadId && !this.submitting && !this.inValidNote;
  }

  inValidMaxLength(): boolean {
    this.inValidNote = this.note.length > 2000;
    return this.inValidNote;
  }

  submit(): void {
    if (this.formIsValid) {
      this.submitting = true;
      const note = this.note ?? '';
      this.actionDataService.leadTakeover(this.leadId, note).subscribe(({success, data}) => {
        if (success) {
          this.clearClassAndCloseDialog(this.dialogRef, 'remove');
        }

        this.submitting = false;
      });
    }
  }
}
